import './RangeCalendar.scss';
import React, { useState, useEffect } from 'react';
import { fr } from 'date-fns/locale';
import { DayPicker } from 'react-day-picker';

export type RangeCalendarProps = {
    selectedDates?: Date[];
    onShownDateChange?: (date: Date) => void;
};

export const RangeCalendar: React.FC<RangeCalendarProps> = ({ 
    selectedDates = [], 
    onShownDateChange
}) => {
    const [selected, setSelected] = useState<Date[]>([]);

    useEffect(() => {
        setSelected(selectedDates);
    }, [selectedDates]);

    return (
        <div>
            <DayPicker 
                numberOfMonths={2}
                pagedNavigation={false}
                locale={fr}
                formatters={{
                    formatWeekdayName: (weekday: Date) => {
                        return weekday.toLocaleString('fr-FR', { weekday: 'long' }).slice(0, 3);
                    }
                }}
                mode='multiple'
                showOutsideDays
                onMonthChange={onShownDateChange}
                disabled
                modifiers={{ selected: selected }}

            />
        </div>
    );
};
